import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface useType {
  [key: string]: any
}

const HfrComponent = ({ user }: useType) => {
  const navigate = useNavigate();
  const goToOverviewPage = () => {
    navigate(`/health-facility/view/${user.facilit_id}`, {
      state: JSON.stringify(user),
    });
  };
  return (
    <div className="hfr-actionWrapper">
      <a onClick={goToOverviewPage}>{user.hfr_id.value}</a>
    </div>
  );
};

export default HfrComponent;
